module.exports = __webpack_public_path__ + "media/src/images/thanks-d7468331a4de6854238cf8e121666ba3.png";